import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {optionFilter} from "../../../utils/filters";
import {remoteOptionFormatter} from "../../../utils/formatters";

class EventReservationList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId, pageSizes: [5,10,15,20,25,30,35,40,45,50,100]};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "EventReservationList"}
                exports={[
                    {
                        as: "excel",
                        label: "Excel",
                        icon: "far fa-file-excel",
                        addFilters: true,
                        currentPage: true,
                        view: [
                            "agent.name",
                            "agent.telnum",
                            "agent.email",
                            "participant_qty",
                            "event.from",
                            "event.to",
                            "event.program.name",
                            "comment.text",
                        ],
                        labels: {
                            "agent.name": "Foglaló",
                            "agent.telnum": "Telefonszám",
                            "agent.email": "Email",
                            "participant_qty": "L.sz.",
                            "event.from": "Időtartam",
                            "event.to": "Időtartam",
                            "event.program.name": "Program",
                            "comment.text": "Megjegyzés",
                        }
                    }
                ]}
                {...props}
                columns={{
                    "id": {header: 'Kód', width: 1, sortable, filterable},
                    "agent.name": {header: 'Foglaló', width: 2, sortable, filterable},
                    "participant_qty": {header: 'L.sz.', width: 1, sortable, filterable, renderer: (value) => value + " Fő"},
                    "event.from": {header: 'Időtartam', width: 1, sortable, filterable},
                    "event.to": {header: 'Időtartam', width: 1, sortable, filterable},
                    "event.locations": {header: 'Hely', width: 2, renderer: (locations) => (locations || []).map((location) => location.name).join(", ")},
                    "event.program.name": {header: 'Program', width: 2, sortable, filterable},
                    "state": {header: 'Státusz', width: 2, sortable, filterable: optionFilter("event_reservation_state"), renderer: remoteOptionFormatter("event_reservation_state")}
                }}
                rowClassName={(rowData) => {
                    if (rowData.state + "" === "2") {
                        return {"success": true};
                    }
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default EventReservationList;
